import { func, number } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useGetSacramentStructures } from "Boards/APIReactQuery/queries";

import FnrLoadingBricks from "UI/FnrLoadingBricks";

import { TABS } from "./AddColumn";
import {
  ExtendedFieldOption,
  ExtendedFieldOptionText,
  ExtendedFieldsOptionsContainer,
  IconContainer,
  LoadingBricksContainer,
} from "./ProfileFieldTab";
import { keys } from "./ProfileFieldsAndSacraments";

export const Loading = ({ margin, color }) => (
  <LoadingBricksContainer margin={margin}>
    <FnrLoadingBricks show color={color || "gray"} size={36} />
  </LoadingBricksContainer>
);

SacramentsList.propTypes = {
  setSelectedSacrament: func,
  boardID: number,
  setActiveKey: func,
};

export default function SacramentsList({
  setSelectedSacrament,
  boardID,
  setActiveKey,
}) {
  const { data, isLoading } = useGetSacramentStructures({ boardID });
  const sacraments = data?.sacraments;

  const handleClick = (sacrament) => {
    setSelectedSacrament(sacrament);
    setActiveKey(keys.SACRAMENT_FIELDS);
  };

  const goBack = () => {
    setSelectedSacrament(undefined);
    setActiveKey(keys.PROFILE_FIELD);
  };

  if (isLoading) {
    return (
      <LoadingContainer>
        <Loading color="blue" margin={0} />
      </LoadingContainer>
    );
  }

  return (
    <>
      <ExtendedFieldsOptionsContainer onClick={(e) => e.stopPropagation()}>
        <H4>
          <IconButton onClick={goBack}>
            <i className={`fas fa-chevron-left`} />
          </IconButton>
          Sacraments
        </H4>
        <Line />
        {sacraments?.map((sacrament, idx) => (
          <ExtendedFieldOption
            key={`add-column-extended-field-${sacrament?.networkFieldID}`}
            type="button"
            onClick={() => {
              handleClick(sacrament);
            }}
          >
            <IconContainer className={`fa-${sacrament?.icon}`} />
            <ExtendedFieldOptionText>
              {sacrament?.title}
            </ExtendedFieldOptionText>
          </ExtendedFieldOption>
        ))}
      </ExtendedFieldsOptionsContainer>
    </>
  );
}

export const H4 = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.35rem;
  margin-block-end: 0.25rem;
  color: #475b68;
  padding: 0.5rem 0.8rem 0 0.8rem;

  & > button {
    margin-inline-end: 0.5rem;
  }
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
`;

export const Line = styled.div`
  margin: 0 0.8rem;
  border-bottom: 1px solid #475b68;
  opacity: 0.15;
`;

export const LoadingContainer = styled.div`
  height: 250px;
  display: grid;
  place-items: center;
  background: #fff;
  border-radius: 5px;
`;
